import { useLivekitContext } from "../../VideoProvider/LivekitProvider";

export const useLivekitWeakSignalIndicator = () => {
  const { isReconnecting } = useLivekitContext();

  return isReconnecting;
};
